<template>
  <div class="containter">
    <lx-header></lx-header>
    <el-form
      :inline="true"
      :model="reqParams"
      ref="reqParams"
      class="demo-form-inline"
      size="small"
    >
      <el-form-item label="类型：">
        <el-radio-group v-model="reqParams.reportType">
          <el-radio :label="0">班报</el-radio>
          <el-radio :label="1">日报</el-radio>
          <el-radio :label="2">周报</el-radio>
          <el-radio :label="3">月报</el-radio>
          <el-radio :label="4">季报</el-radio>
          <el-radio :label="5">年报</el-radio>
          <el-radio :label="6">定制</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="开始时间：">
        <div class="block">
          <el-date-picker
            class="report_date"
            v-model="defaultTime"
            type="datetime"
            placeholder="选择日期时间"
            default-time="12:00:00"
          >
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="定制报表时间长度(小时)：">
        <el-input-number
          v-model="reqParams.timeSpan"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        label="邮箱地址："
        prop="email"
        :rules="[
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' },
        ]"
      >
        <el-input placeholder="请输入邮箱" v-model="reqParams.email" clearable>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="reqParams.sendMail">发送</el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit()">提交</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="ReportPage">返回</el-button>
      </el-form-item>
    </el-form>
    <br />
    <div class="report" v-if="isShow">
      <div class="title">{{ data.reportName }}</div>
      <br />
      <!-- 图例 -->
      <el-row>
        <el-col :span="2" :offset="18">
          <div class="border center">
            <div class="legendHeight">图例颜色说明：</div>
          </div>
        </el-col>
        <el-col :span="2">
          <div>
            <div class="border bgColorYellow"></div>
          </div>
        </el-col>
        <el-col :span="2">
          <div class="center">
            <div class="border reaForAlarmText legendHeight">触发报警原因</div>
          </div>
        </el-col>
      </el-row>
      <br />
      <!-- 综合评估分 -->
      <div class="border bgColorBlue">
        <el-row :offset="18">
          <el-col :span="3">
            <div class="comEvaScore">综合评估分：{{ data.score }}</div>
          </el-col>
          <el-col :span="3">
            <div class="type">类型：{{ data.reportType }}</div>
          </el-col>
          <el-col :span="14">
            <el-row>
              <el-col :span="7">
                <div class="startTime">开始时间：{{ data.startTime }}</div>
                <div class="endTime">截止时间：{{ data.endTime }}</div>
              </el-col>
              <el-col :span="17">
                <div class="endTime" v-show="reqParams.reportType == 0">
                  班组：{{ data.groupName }}
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="4">
            <div class="reportGenTime">报告生成时间：{{ data.reportTime }}</div>
          </el-col>
        </el-row>
      </div>
      <!-- 分类统计 -->
      <div class="subtitle">分类统计</div>
      <el-table
        :data="this.initUnitScore"
        max-height="170px"
        style="width: 100%; margin-top: 10px"
        :header-cell-style="{
          textAlign: 'center',
          fontSize: '18px',
          color: 'white',
        }"
        :cell-style="{ color: 'white', fontSize: '16px', textAlign: 'center' }"
      >
        <el-table-column prop="positionName" label="单元名称" width="200">
        </el-table-column>
        <el-table-column prop="avgScore" label="单元平均" width="210">
        </el-table-column>
        <el-table-column prop="conInd" label="工况指数" width="210">
        </el-table-column>
        <el-table-column prop="stableInd" label="稳定指数" width="210">
        </el-table-column>
        <el-table-column prop="optInd" label="优化指数" width="210">
        </el-table-column>
        <el-table-column label="报警次数">
          <el-table-column prop="almSum" label="总数" width="215">
          </el-table-column>
          <el-table-column prop="almStable" label="异常工况/波动" width="210">
          </el-table-column>
        </el-table-column>
        <el-table-column label="预警次数">
          <el-table-column prop="preAlmSum" label="总数" width="222">
          </el-table-column>
          <el-table-column
            prop="preAlmStable"
            label="异常工况/波动"
            width="210"
          >
          </el-table-column>
        </el-table-column>
      </el-table>
      <!-- 模型明细 -->
      <div class="subtitle">模型明细</div>
      <el-table
        :data="data.modelDetailList"
        max-height="265px"
        border
        style="width: 100%; margin-top: 10px"
        :header-cell-style="{
          textAlign: 'center',
          fontSize: '18px',
          color: 'white',
        }"
        :cell-style="{ color: 'white', fontSize: '16px', textAlign: 'center' }"
      >
        <el-table-column prop="modelName" label="模型"> </el-table-column>
        <el-table-column prop="positionName" label="所属单位">
        </el-table-column>
        <el-table-column prop="conInd" label="工况指数"> </el-table-column>
        <el-table-column prop="stableInd" label="稳定指数"> </el-table-column>
        <el-table-column prop="optInd" label="优化指数"> </el-table-column>
      </el-table>
      <!-- 报警记录 -->
      <div class="subtitle">报警记录</div>
      <el-table 
        :data="data.alarmRecordList" 
        border
        style="width: 100%; margin-top: 10px"
        max-height="200px"
        :header-cell-style="headFirst"
        :cell-style="{ color: 'white', textAlign: 'center', fontSize: '16px' }"
      >
        <el-table-column prop="sortNo" label="序号" width="80">
        </el-table-column>
        <el-table-column prop="alarmType" label="类型" width="80">
        </el-table-column>
        <el-table-column label="系统分析结果">
          <template slot-scope="scope">
            <el-row>
              <el-col :span="6">
                <el-col :span="12">
                  <div class="list">开始时间</div>
                  <div class="list" style="height:50px;line-height:50px">{{scope.row.startTime}}</div>
                  <div class="list">单元</div>
                  <div class="list">装置/设备</div>
                  <div class="list">工况指数最小值</div>
                  <div class="list">稳定指数最小值</div>
                </el-col>
                <el-col :span="12">
                  <div class="list borderRight">结束时间</div>
                  <div class="list borderRight" style="height:50px;line-height:50px">{{scope.row.endTime}}</div>
                  <div class="list borderRight">{{scope.row.positionName}}</div>
                  <div class="list borderRight">{{scope.row.modelName}}</div>
                  <div class="list borderRight" :style="{'background-color': scope.row.highlightOfCon == true ? '#f4b084':'#000617'}">{{scope.row.conIndMin}}</div>
                  <div class="list borderRight" :style="{'background-color': scope.row.highlightOfStable == true ? '#f4b084':'#000617'}">{{scope.row.stableIndMin}}</div>
                </el-col>
              </el-col>
              <el-col :span="18">
                <div class="list">{{scope.row.alarmReason}}</div>
                <el-table 
                  :data="scope.row.altTagScoreList" 
                  border
                  style="width: 100%"
                  :header-cell-style="headFirst"
                  :cell-style="{ color: 'white', textAlign: 'center',height:'25px' }"
                >
                  <el-table-column prop="sortNo" label="次序" width="80">
                  </el-table-column>
                  <el-table-column prop="tagName" label="位号" width="250">
                  </el-table-column>
                  <el-table-column prop="contribt" label="占比" width="80">
                  </el-table-column>
                  <el-table-column prop="inputMax" label="最大值" width="80">
                  </el-table-column>
                  <el-table-column prop="inputMin" label="最小值" width="80">
                  </el-table-column>
                  <el-table-column prop="stableValue" label="波动强度" width="80">
                  </el-table-column>
                  <el-table-column prop="tagDesc" label="描述">
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getReportDetail } from "@/api/wormBox";

export default {
  data() {
    return {
      isShow:false,
      defaultTime: "",
      message:null,
      reqParams: {
        reportType: 0, //报表类型
        workShopName: "",
        startTime: 0, //开始时间：时间戳
        timeSpan: 1, //时间间隔
        email: "", //邮件地址
        sendMail: true, //是否邮件
      },
      initUnitScore:[],
      data: {
        reportName: "XX公司 XX模式化监控 模式化监控报表",
        score: "99",
        reportType: "周报",
        groupName: "一班",
        startTime: "2023/8/21 0:00:01",
        endTime: "2023/8/21 0:00:01",
        reportTime: "2023/8/21 0:00:01",
        unitScore: {
          positionUnitCoreList: [
            {
              positionName: "单元一",
              avgScore: 88.9,
              conInd: 78,
              stableInd: 87,
              optInd: 97,
              almSum: 3,
              almStable: 5,
              preAlmSum: 8,
              preAlmStable: 7,
            },
          ],
        },
        modelDetailList: [
          {
            modelName: "模型1",
            positionName: 88.9,
            conInd: 78,
            stableInd: 87,
            optInd: 97,
          },
        ],
        alarmRecordList: [
          {
            sortNo: 1,
            startTime: "2023-12-11 13:01:32",
            endTime: "2023-12-11 13:59:32",
            alarmType: "报警",
            positionName: "聚合",
            modelName: "PVC聚合4#釜八型",
            conIndMin: 0.0,
            stableIndMin: 99.46,
            highlightOfCon: true,
            highlightOfStable: false,
            alarmReason:
              "导致工况异常的前5个可能原因(工位号见下). 触发警告的可能性总和为: 100.0%",
            altTagScoreList: [
              {
                sortNo: 1,
                tagName: "JI1101DH",
                contribt: 10.0,
                inputMax: 0.54,
                inputMin: 0.54,
                stableValue: 0.0,
                tagDesc: "[280/20.0]4#聚合釜搅拌功率KW)",
              },
              {
                sortNo: 2,
                tagName: "TIC1121D",
                contribt: 0.0,
                inputMax: 42.29,
                inputMin: 42.29,
                stableValue: 0.0,
                tagDesc: "[70.0/-]4#聚合釜釜温_℃)",
              },
              {
                sortNo: 3,
                tagName: "TI1124D",
                contribt: 0.0,
                inputMax: 44.34,
                inputMin: 44.34,
                stableValue: 0.0,
                tagDesc: "[80.0/15.0]4#聚合釜釜温_℃)",
              },
              {
                sortNo: 4,
                tagName: "PI1123D",
                contribt: 0.0,
                inputMax: 0.06,
                inputMin: 0.06,
                stableValue: 0.0,
                tagDesc: "[1.25/-0.080]4#聚合釜釜压_Mpa)",
              },
              {
                sortNo: 5,
                tagName: "PI1121D",
                contribt: 0.0,
                inputMax: 0.06,
                inputMin: 0.06,
                stableValue: 0.0,
                tagDesc: "[1.25/-0.080]4#聚合釜釜压_Mpa)",
              },
            ],
          }
        ],
      },
    };
  },
  methods: {
    ReportPage() {
      this.$router.push({
        path: "/report",
        query: { homePage: this.$route.query.homePage },
      });
    },
    async submit() {
      this.message = this.$message({
          dangerouslyUseHTMLString: true,
          center: true,
          duration:0,
          message: '<strong><i class="el-icon-loading"></i> 加载中。。。</strong>'
      });
      this.reqParams.startTime = this.defaultTime.getTime();
      this.reqParams.workShopName = this.$route.query.homePage;
      const { code, resultData } = await getReportDetail(this.reqParams);
      if (code == "200") {
        this.data = resultData
        //小计是分开的
        this.data.unitScore.positionUnitCoreList.map(item => {
          this.initUnitScore.push(item)
        })
        delete this.data.unitScore.positionUnitCoreList
        this.data.unitScore.positionName = "小计"
        this.initUnitScore.push(this.data.unitScore)
        
        this.isShow = true
        this.message.close()
        this.message = null
      }else{
        this.message.close()
        this.message = null
      }
    },
    //合并表头
    headFirst({ row, colunm, rowIndex, columnIndex }) {
      if (rowIndex === 1) {
        return { display: "none" };
      } else {
        return { color: "white", textAlign: "center", fontSize: "16px" };
      }
    },
  },
  created() {
    this.defaultTime = new Date();
    this.defaultTime.setHours(this.defaultTime.getHours() - 1);
  },
  beforeDestroy(){
    if(this.message != null){
      this.message.close()
    }
  }
};
</script>

<style lang="less" scoped>
.containter {
  color: white;
  height: 920px;
  width: 1920px;
  .el-radio {
    margin-right: 15px;
    color: white;
  }
  /deep/.el-radio__inner {
    width: 15px;
    height: 15px;
  }
  /deep/.el-radio__label {
    padding-left: 5px;
  }
  /deep/.el-form-item {
    margin-bottom: 0;
    padding-right: 0;
    margin-right: 20px;
  }
  /deep/.el-form-item__label {
    color: white;
  }
  .block {
    /deep/ .el-input__inner {
      padding: 0 40px;
    }
  }
  /deep/.el-form-item__label {
    padding-right: 10px;
  }
  .el-button--primary {
    color: white;
    background-color: transparent;
  }
  .report {
    font-size: 18px;
    color: white;
    margin: 0 10px 0 10px;
    .title {
      font-size: 24px;
      text-align: center;
      // background-color: #9bb38d;
      border: 1px solid white;
      font-weight: bold;
      height: 40px;
      line-height: 40px;
    }
    .subtitle {
      font-size: 20px;
    }
    .border {
      border: 1px solid white;
    }
    .bgColorGrey {
      height: 23px;
      background: #bfbfbf;
    }
    .bgColorYellow {
      height: 24px;
      background: #f4b084;
    }
    .center {
      text-align: center;
    }
    .legendHeight {
      height: 24px;
    }
    .comEvaScore,
    .type,
    .reportGenTime {
      height: 42px;
      line-height: 42px;
    }
    .reportGenTime {
      text-align: right;
    }
    // .bgColorBlue {
    //   background: #96bbd9;
    // }
    /deep/ .el-table th {
      background-color: transparent !important;
    }
    /deep/ .el-table tr,
    .el-table td {
      background-color: #000617;
      font-size: 14px;
    }
    /deep/ .el-table tbody tr:hover > td {
      background-color: rgb(131, 151, 238);
    }
    /deep/.el-table .el-table__cell {
      padding: 0;
    }
    :deep(.el-table__row .bgHighlight) {
      background: #f4b084;
    }
    /deep/.el-table .cell{
      padding: 0;
    }
    .list{
      text-align: center;
      border: 1px solid white;
      border-left: 0;
      border-bottom: 0;
      margin: 0;
      height: 25px;
    }
    .borderRight{
      border-right: 0;
    }
  }
}
</style>
